import request from '@/utils/request';

export function wechatShare() {
  const ajaxurl = window.location.href.split('#')[0];
  return request({
    url: 'https://wapp.gz-cmc.com/index.php/open/index/getWxSign',
    params: {
      appid: 'wxe2c60845a8749dc5',
      url: ajaxurl,
    },
    method: 'get',
  });
}

export function test() {}
